import { GetFeaturesResponseDto, GetFormRoleFieldSettingsResponseDto, SaveFieldPermissionDto, UserRoleKey } from "../../../main/second/mainbar/settings/FeatureControl/types";
import { requests } from "../config";
import { PRODUCT_CREATION_FORM_ID } from "../../../main/second/mainbar/settings/FeatureControl/constants/formlist";


export const UI_FORMS = {
    getFeatures: (): Promise<GetFeaturesResponseDto> => requests.get('uiform/features', 'go'),
    // uiform/field_settings?FormID=1&Roles=23

    getFieldSettings: (formId: number, roles: UserRoleKey[]): Promise<GetFormRoleFieldSettingsResponseDto> => requests.get(`uiform/field_settings?FormID=${formId}&Roles=${roles.join(',')}`, 'go'),
    changeFieldSettings: (fields: SaveFieldPermissionDto[]): Promise<void> => requests.put('uiform/field_settings', 'go', fields),

}